import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  container: {
    minHeight: '100vh',
    display: 'flex',
    padding: '0 18px',
  },
}));

export default useStyles;